// 定义常量
export const RemarkMap = {
    '神翼': {
        'AP1': 'https://v.qq.com/iframe/player.html?vid=k0330f1wgvo',
        '2AA': 'https://v.qq.com/iframe/player.html?vid=c0330yr42y8',
        '2BB': 'https://v.qq.com/iframe/player.html?vid=t0330hcg3ag',
        '2CC': 'https://v.qq.com/iframe/player.html?vid=k0330z262me',
        'AP3': 'https://v.qq.com/iframe/player.html?vid=g0330l2c30j',
        'AP4': 'https://v.qq.com/iframe/player.html?vid=i0330kx3nr5'
    },
    '风翼': {
        'AP1': 'https://v.qq.com/txp/iframe/player.html?vid=f32082ktwws',
        '2AA': 'https://v.qq.com/txp/iframe/player.html?vid=h3207okbonm',
        '2BB': 'https://v.qq.com/txp/iframe/player.html?vid=y3207oe098d',
        'AP3': 'https://v.qq.com/iframe/player.html?vid=g0330l2c30j',
        'AP4': 'https://v.qq.com/txp/iframe/player.html?vid=p3208swcks7',
        '2CC': 'https://www.bosch-trading.com.cn/mobile/wiper/2cc/'
    },
    '坤翼': {
        'AP1': 'https://v.qq.com/txp/iframe/player.html?vid=d3207zvekgm',
        '2AA': 'https://v.qq.com/txp/iframe/player.html?vid=n3207c5pwl7',
        '2BB': 'https://v.qq.com/txp/iframe/player.html?vid=w32078d4exc',
        'AP4': 'https://v.qq.com/txp/iframe/player.html?vid=f3207mc8eyo',
        '2CC': 'https://www.bosch-trading.com.cn/mobile/wiper/2cc/'
    },
    '容翼': {
        '1A': 'https://boschaacnpdtvideoblob.blob.core.chinacloudapi.cn/qr-pdt/video/FB3_1A.mp4',
        '1B': 'https://boschaacnpdtvideoblob.blob.core.chinacloudapi.cn/qr-pdt/video/FB3_1B.mp4',
        '2A': 'https://boschaacnpdtvideoblob.blob.core.chinacloudapi.cn/qr-pdt/video/FB3_2A.mp4',
        '2C': 'https://boschaacnpdtvideoblob.blob.core.chinacloudapi.cn/qr-pdt/video/FB3_2C.mp4',
        'AP3': 'https://boschaacnpdtvideoblob.blob.core.chinacloudapi.cn/qr-pdt/video/FB3_AP3.mp4',
        'AP4': 'https://boschaacnpdtvideoblob.blob.core.chinacloudapi.cn/qr-pdt/video/FB3_AP4.mp4',
        'AP6': 'https://boschaacnpdtvideoblob.blob.core.chinacloudapi.cn/qr-pdt/video/FB3_AP6.mp4'
    },
    '容翼Pro': {
        'AP1': '/file/download/video/01',
        'AP3': '/file/download/video/03',
        'AP4': '/file/download/video/04',
        'AP5': '/file/download/video/05',
        'AP6': '/file/download/video/06',
        'AP7': '/file/download/video/07',
        'AP9': '/file/download/video/09'
    }
};

// 定义实用方法
export class EcatUtils {
    static mapRemark(remark: any, categoryName: any) {
        if (!remark) {
            return
        }
        switch (categoryName) {
            case '神翼':
                switch (remark) {
                    case 'AP4':
                        return '#4号卡扣(神翼)'
                    case 'AP1':
                        return '#1号卡扣(神翼)'
                    case 'AP3':
                        return '#3号卡扣(神翼)'
                    case '2AA':
                        return '#2号卡扣(神翼)'
                    case '2BB':
                        return '#2号卡扣(神翼)'
                    case '2CC':
                        return '#2号卡扣(神翼)'
                    default:
                        return ''
                }
            case '容翼Pro':
                switch (remark) {
                    case 'AP1':
                        return '#1号卡扣(容翼Pro)'
                    case 'AP3':
                        return '#3号卡扣(容翼Pro)'
                    case 'AP4':
                        return '#4号卡扣(容翼Pro)'
                    case 'AP5':
                        return '#5号卡扣(容翼Pro)'
                    case 'AP6':
                        return '#6号卡扣(容翼Pro)'
                    case 'AP7':
                        return '#7号卡扣(容翼Pro)'
                    case 'AP9':
                        return '#9号卡扣(容翼Pro)'
                    default:
                        return ''
                }
            case '坤翼':
                switch (remark) {
                    case 'AP4':
                        return '#4号卡扣(坤翼)'
                    case 'AP1':
                        return '#1号卡扣(坤翼)'
                    case '2AA':
                        return '#2号卡扣(坤翼)'
                    case '2BB':
                        return '#2号卡扣(坤翼)'
                    case '2CC':
                        return '#2号卡扣(坤翼)'
                    default:
                        return ''
                }
            case '风翼':
                switch (remark) {
                    case 'AP4':
                        return '#4号卡扣(风翼)'
                    case 'AP1':
                        return '#1号卡扣(风翼)'
                    case 'AP3':
                        return '#3号卡扣(风翼)'
                    case '2AA':
                        return '#2号卡扣(风翼)'
                    case '2BB':
                        return '#2号卡扣(风翼)'
                    case '2CC':
                        return '#2号卡扣(风翼)'
                    default:
                        return ''
                }
            case '容翼':
                switch (remark) {
                    case 'AP4':
                        return '#4号卡扣(容翼)'
                    case 'AP3':
                        return '#3号卡扣(容翼)'
                    case 'AP6':
                        return '#6号卡扣(容翼)'
                    case '1A':
                        return '#1号卡扣(容翼)'
                    case '1B':
                        return '#1号卡扣(容翼)'
                    case '2A':
                        return '#2号卡扣(容翼)'
                    case '2C':
                        return '#2号卡扣(容翼)'
                    default:
                        return ''
                }
            default:
                return remark;
        }
    }
}
